<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

// Define props
defineProps({
    centerPlan: {
        type: Object,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                link: rawValue => rawValue.link === undefined || typeof rawValue.link === 'string'
            }

            return Object.entries(validations).every(([_, validate]) => validate(rawValue))
        }
    }
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)
</script>

<template>
    <section class="shop-map-wrapper">
        <div class="shop-map-container">
            <ContentHeadline :content-headline-config="{ title: staticKeys?.shops_details_location_headline_web_markdown, renderSplit: true }" />
            <div class="iframe-container">
                <iframe
                    :src="centerPlan?.link"
                    width="100%"
                    height="800"
                />
            </div>
        </div>
    </section>
</template>

<style lang="scss">
.shop-map-wrapper {
    margin: 0 auto 20px;

    @include bp(medium1) {
        margin: 0 auto 40px;
    }

    @include bp(large2) {
        margin: 0 auto 60px;
    }
}

.shop-map-container {
    .iframe-container {
        position: relative;
        width: 100%;
        max-width: $component-width;
        margin: 0 auto;

        @media (orientation: portrait) {
            aspect-ratio: 345 /423;
        }

        @media (orientation: landscape) {
            aspect-ratio: 704/ 414;
        }

        iframe {
            position: absolute;
            inset: 0;
            border: $shop-map-border 3px solid;
            height: 100%;
            max-width: 100%;
            border-radius: 32px;
        }
    }
}
</style>
